<div class="p500-ui-form-field">
  <p500-ui-text-field [label]="label" [formControl]="control"></p500-ui-text-field>
</div>
